import { render, staticRenderFns } from "./StatusEditor.vue?vue&type=template&id=ffcc2448"
import script from "./StatusEditor.vue?vue&type=script&lang=js"
export * from "./StatusEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports